<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title10"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title10"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439614785_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439614785_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<a class="toc_entry_dedicationPage" href="#/e9781439614785_ded01"><span>Dedication</span></a><br/>
<a class="toc_entry_acknowPage" href="#/e9781439614785_ack01"><span>Acknowledgements</span></a><br/>
<a class="toc_entry_forewordPage" href="#/e9781439614785_frw01"><span><strong class="b">FOREWORD</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/e9781439614785_c01"><span><strong class="b">ONE</strong> - <strong class="b"><em class="i">19th Century</em></strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439614785_c02" title="Link target outside of Sample"><span><strong class="b">TWO</strong> - <strong class="b"><em class="i">The Big Fix</em></strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439614785_c03" title="Link target outside of Sample"><span><strong class="b">THREE</strong> - <strong class="b"><em class="i">1926 Chicago Boxing Goes Legit</em></strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439614785_c04" title="Link target outside of Sample"><span><strong class="b">FOUR</strong> - <strong class="b"><em class="i">Ross, Louis and Zale...</em></strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439614785_c05" title="Link target outside of Sample"><span><strong class="b">FOUR</strong> - <strong class="b"><em class="i">After the Golden Age</em></strong></span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439614785_toc01.vue?03ef0dc1